import { Component, input } from '@angular/core';

@Component({
  selector: 'page-title',
  imports: [],
  templateUrl: './page-title.html',
  styles: ``,
})
export class PageTitle {
  readonly title = input<string>('Working Page Title');
}
